export function TripleCoinsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.0001 38.0282C11.6049 38.0282 3.97183 30.386 3.97183 20.9999C3.97183 11.6139 11.6049 3.97168 21.0001 3.97168C30.3953 3.97168 38.0284 11.6139 38.0284 20.9999C38.0284 30.386 30.3862 38.0282 21.0001 38.0282Z"
        fill="url(#paint0_linear_21268_24277)"
      />
      <path
        d="M34.3576 22.9083H34.3484C34.3576 22.9722 34.3576 23.0361 34.3576 23.1C34.3576 29.3178 28.3771 34.3578 20.9997 34.3578C13.6223 34.3578 7.65103 29.3178 7.65103 23.1C7.65103 23.0361 7.65103 22.9722 7.66016 22.9083H7.65103V18.7539H34.3576V22.9083Z"
        fill="url(#paint1_linear_21268_24277)"
      />
      <path
        d="M20.9999 30.1577C28.3773 30.1577 34.3486 25.1177 34.3486 18.8999C34.3486 12.6821 28.3682 7.64209 20.9999 7.64209C13.6316 7.64209 7.6512 12.6821 7.6512 18.8999C7.6512 25.1177 13.6316 30.1577 20.9999 30.1577Z"
        fill="url(#paint2_linear_21268_24277)"
      />
      <path
        d="M20.9995 27.2451C26.4595 27.2451 30.8969 23.5108 30.8969 18.8999C30.8969 14.289 26.4687 10.5547 20.9995 10.5547C15.5304 10.5547 11.1021 14.289 11.1021 18.8999C11.1021 23.5108 15.5304 27.2451 20.9995 27.2451Z"
        fill="url(#paint3_linear_21268_24277)"
      />
      <path
        opacity="0.8"
        d="M17.0556 23.1912C15.9691 23.1912 15.0469 22.9264 14.3895 22.4334C13.8508 22.0225 13.5769 21.5112 13.5769 20.9177C13.5769 20.0138 14.2434 19.3199 15.1473 19.2742C14.9099 19.0003 14.7638 18.6351 14.7638 18.2425C14.7638 17.8499 14.9008 17.5029 15.1291 17.229C14.4078 17.0647 13.8873 16.4164 13.8873 15.6129C13.8873 15.1108 14.1338 14.636 14.5721 14.2799C15.1747 13.7777 16.1517 13.4673 17.1104 13.4673C19.1099 13.4673 20.5069 14.6725 20.5069 16.3982C20.5069 17.0099 20.3334 17.5669 20.0138 18.0325C20.4978 18.5438 20.7625 19.2103 20.7625 19.9682C20.7625 21.8308 19.2012 23.1821 17.0465 23.1821L17.0556 23.1912Z"
        fill="url(#paint4_linear_21268_24277)"
      />
      <path
        d="M18.6535 18.1328C19.4113 18.4615 19.9044 19.0915 19.9044 19.9771C19.9044 21.3558 18.7448 22.3145 17.0648 22.3145C16.1061 22.3145 15.394 22.0863 14.9283 21.7393C14.6361 21.511 14.4626 21.2645 14.4626 20.9176C14.4626 20.461 14.7822 20.1415 15.257 20.1415C15.4944 20.1415 15.7318 20.2419 15.96 20.4154C16.2522 20.6163 16.6083 20.735 17.074 20.735C17.6766 20.735 18.124 20.3515 18.124 19.8493C18.124 19.3471 17.7496 18.9728 16.9279 18.9728H16.4348C16.0057 18.9728 15.6496 18.6806 15.6496 18.2423C15.6496 17.8041 16.0057 17.5119 16.4348 17.5119H16.9005C17.5031 17.5119 17.9231 17.1923 17.9231 16.7267C17.9231 16.261 17.5122 15.9232 16.9644 15.9232C16.59 15.9232 16.307 16.0693 16.0422 16.2337C15.8596 16.3432 15.7044 16.4071 15.5126 16.4071C15.0926 16.4071 14.7731 16.0784 14.7731 15.6219C14.7731 15.3937 14.8826 15.1654 15.1383 14.9645C15.54 14.6358 16.2979 14.3528 17.1287 14.3528C18.5531 14.3528 19.6487 15.0923 19.6487 16.4071C19.6487 17.0737 19.3383 17.7584 18.6444 18.1328H18.6535Z"
        fill="white"
      />
      <path
        opacity="0.8"
        d="M26.6333 23.1912C26.1311 23.1912 25.6472 22.9629 25.3003 22.5612L24.8346 22.0134L24.3781 22.5612C24.0494 22.9629 23.5837 23.1821 23.0542 23.1821C22.1137 23.1821 21.3194 22.3877 21.3194 21.4473C21.3194 21.0182 21.4837 20.6073 21.8124 20.2329L22.5155 19.4569L21.8672 18.7356C21.5568 18.4069 21.3742 17.9686 21.3742 17.5121C21.3742 16.5443 22.1594 15.759 23.1181 15.759C23.6568 15.759 24.1316 15.9782 24.4603 16.3708L24.8985 16.9095L25.355 16.3708C25.6746 15.9782 26.1494 15.759 26.6698 15.759C27.6103 15.759 28.4046 16.5534 28.4046 17.4938C28.4046 17.9229 28.2403 18.3338 27.9024 18.7082L27.1994 19.4751L27.8568 20.1599C28.1946 20.516 28.3772 20.9634 28.3772 21.4108C28.3772 22.3695 27.5737 23.1821 26.6242 23.1821L26.6333 23.1912Z"
        fill="url(#paint5_linear_21268_24277)"
      />
      <path
        d="M25.9942 21.9495L24.8255 20.5708L23.6659 21.9678C23.5107 22.1595 23.3007 22.2599 23.0542 22.2599C22.6251 22.2599 22.2507 21.8856 22.2507 21.4473C22.2507 21.2465 22.3329 21.0456 22.5155 20.8447L23.7664 19.4569L22.5612 18.1147C22.3785 17.923 22.3055 17.7039 22.3055 17.5121C22.3055 17.0556 22.6798 16.6812 23.1272 16.6812C23.3555 16.6812 23.5838 16.7543 23.7572 16.9552L24.8985 18.343L26.0672 16.9643C26.2225 16.7726 26.4325 16.6721 26.679 16.6721C27.1172 16.6721 27.4916 17.0465 27.4916 17.4756C27.4916 17.6765 27.4094 17.8773 27.2268 18.0782L25.9485 19.466L27.1994 20.7808C27.382 20.9726 27.4642 21.1917 27.4642 21.3926C27.4642 21.8399 27.0898 22.2326 26.6333 22.2326C26.3959 22.2326 26.1585 22.1139 25.9942 21.9221V21.9495Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21268_24277"
          x1="17.3662"
          y1="47.1678"
          x2="23.8123"
          y2="0.730376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E700" />
          <stop offset="0.52" stopColor="#00FF00" stopOpacity="0.89" />
          <stop offset="0.62" stopColor="#19FF00" stopOpacity="0.91" />
          <stop offset="0.82" stopColor="#59FF00" stopOpacity="0.95" />
          <stop offset="1" stopColor="#99FF00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_21268_24277"
          x1="6.82016"
          y1="48.7383"
          x2="25.4554"
          y2="13.7778"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005933" />
          <stop offset="0.2" stopColor="#005C31" />
          <stop offset="0.37" stopColor="#00662E" />
          <stop offset="0.52" stopColor="#007727" />
          <stop offset="0.67" stopColor="#008F1F" />
          <stop offset="0.81" stopColor="#00AE14" />
          <stop offset="0.95" stopColor="#00D406" />
          <stop offset="1" stopColor="#00E600" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_21268_24277"
          x1="32.6047"
          y1="3.6247"
          x2="13.5221"
          y2="28.7334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00DE00" />
          <stop offset="1" stopColor="#00B800" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_21268_24277"
          x1="15.2839"
          y1="30.2673"
          x2="32.0747"
          y2="-3.1227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005933" stopOpacity="0.6" />
          <stop offset="0.26" stopColor="#006C2B" stopOpacity="0.52" />
          <stop offset="0.64" stopColor="#00A218" stopOpacity="0.29" />
          <stop offset="1" stopColor="#00E600" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_21268_24277"
          x1="19.3656"
          y1="11.7142"
          x2="15.6038"
          y2="23.2369"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1FF58" stopOpacity="0.5" />
          <stop offset="1" stopColor="#00FF00" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_21268_24277"
          x1="26.6516"
          y1="14.0699"
          x2="22.8807"
          y2="25.6016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1FF58" stopOpacity="0.5" />
          <stop offset="1" stopColor="#00FF00" stopOpacity="0.2" />
        </linearGradient>
      </defs>
    </svg>
  )
}
